import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'src/app/core/config/application-config.service';
import { TempRequestService } from 'src/app/core/services/temp-request.service';
import { ActionTypeEnum } from 'src/app/shared/Entity/action-type.enum';
import { FeatureCodeEnum } from 'src/app/shared/Entity/feature-code.enum';
import { CommonService } from 'src/app/shared/services/common.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicMenuService {
  resourceUrl: any;
  requestUrl: any;

  constructor(
    protected http: HttpClient,
    protected commonService: CommonService,
    protected applicationConfigService: ApplicationConfigService,
    protected tempRequestService: TempRequestService,
  ) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('account-portal/menu');
    this.requestUrl = this.applicationConfigService.getRequestUrlFor('account-portal/menu');
  }

  allCategory(): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/category/all`, { observe: 'response' });
  }

  menuByCategory(categoryId: any) {
    return this.http.get<any>(`${this.resourceUrl}/category/${categoryId}`, { observe: 'response' });
  }

  menuById(menuId: any) {
    return this.http.get<any>(`${this.resourceUrl}/${menuId}`, { observe: 'response' });
  }
  assignedMenus() {
    return this.http.get<any>(`${this.resourceUrl}/assigned/me`, { observe: 'response' });
  }

  menuByRole(roleId: any) {
    return this.http.get<any>(`${this.resourceUrl}/tree/${roleId}`, { observe: 'response' });
  }

  availableSubMenus(parentId: any, roleId: any) {
    return this.http.get<any>(`${this.resourceUrl}/available/${parentId}/${roleId}`, { observe: 'response' });
  }

  create(data: any): Observable<any> {
    const payload = {
      data,
      url: `${this.requestUrl}/create`,
      actionType: ActionTypeEnum.POST,
      featureCode: FeatureCodeEnum.CREATE_MENU,
      remarks: FeatureCodeEnum.CREATE_MENU,
    };
    return this.tempRequestService.makeRequest(payload);
  }

  update(data: any, displayData?: any, remarksDetails?: any): Observable<any> {
    const payload = {
      data,
      displayData,
      remarksDetails,
      url: `${this.requestUrl}/update`,
      actionType: ActionTypeEnum.POST,
      featureCode: FeatureCodeEnum.EDIT_MENU,
      remarks: FeatureCodeEnum.EDIT_MENU,
    };
    return this.tempRequestService.makeRequest(payload);
  }

  delete(menuId: any): Observable<any> {
    const payload = {
      data: null,
      url: `${this.requestUrl}/remove/${menuId}`,
      actionType: ActionTypeEnum.DELETE,
      featureCode: FeatureCodeEnum.DELETE_MENU,
      remarks: FeatureCodeEnum.DELETE_MENU,
    };
    return this.tempRequestService.makeRequest(payload);
  }
}
